/**
 * analytics module (Wrapper around iStats)
 * @author Ardeshir Eshghi
 *
 */

let istats;

const Utils = require('./utils');

const utils = new Utils();

if (window.require) {
    window.require(['istats-1'], (istatsImport) => {
        istats = istatsImport;
        console.info('iStats setup.');
    });
}

const alreadyLoggedNotifications = [];

module.exports = {
    /**
     * @param {Object} trackings Key value pair of linkType: options
     */
    track(trackings) {
        utils.each(trackings, (properties, linkType) => {
            istats.track(linkType, properties);
        });

        return this;
    },

    /**
     * Adds a new action handler for the actionName
     * @param {string} actionName
     * @param {string} istatsName
     */
    log(actionType, actionName, options) {
        if (istats) {
            istats.log(actionType, actionName, options);
        } else {
            console.error('iStats not setup.');
        }
    },

    serialiseTopic(topic) {
        let serialisedTopic;

        serialisedTopic = topic.slice(0, 5).join('!').replace(/urn:bbc:/g, '').replace(/:/g, '-');
        serialisedTopic = (topic.length > 5) ?
            serialisedTopic.concat('!more than 5')
            : serialisedTopic;

        return serialisedTopic;
    },

    logNewNotifications(list, mainApp) {
        if (mainApp.getDrawerState() === 'shown') {
            console.log('Checking for new notifications to log');

            list.forEach((item) => {
                if (item.status === 'new' && !alreadyLoggedNotifications.includes(item.id)) {
                    this.log('seen', 'notifications-item', {
                        notifications_id: item.id,
                        notifications_state: 'blueDot',
                        notifications_priority: (item.priority || 'normal').toLowerCase(),
                        notifications_product: item.product.toLowerCase(),
                        notifications_type: item.type.toLowerCase(),
                        notifications_title: item.notification.title,
                        topic_name: this.serialiseTopic(item.topic)
                    });

                    alreadyLoggedNotifications.push(item.id);
                }
            });
        }
    }
};



/** WEBPACK FOOTER **
 ** ./assets/js/analytics.js
 **/